/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { find, get } from 'lodash';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';

import ResultsList from '../../../../ResultsList';
import PopOverMenu from '../../../../PopOverMenu';
import SidePanel from '../../SidePanel';
import SidePanelBottomSection from '../../SidePanelBottomSection';
import SidePanelTopSection from '../../SidePanelTopSection';
import {
    isActive, isHighSchoolClub,
} from '../../../../../utils/clubs';
import LoadingText from '../../../../text/LoadingText';

import styles from '../../../../../pages/ClubProfiles/club.scss';

const _ = { find, get };

const ResultsTabContent = (props) => {
    const {
        clubDetails,
        auth,
        isAdminOrOwner,
        clubType,
        handleUploadPhoto,
        handleUploadLogoStart,
        removeSponsorLogo,
        resultsType,
        results,
        sendMessage,
        resultsFetchState,
        fetchClubResults,
        highSchoolStandingsSeasons,
        getHighSchoolStandingsSeasons,
    } = props;

    const {
        tierType,
    } = clubDetails;

    const [selectedSeason, setSelectedSeason] = useState(null);

    const isHighschool = isHighSchoolClub(tierType);

    useEffect(() => {
        if (isHighschool) {
            getHighSchoolStandingsSeasons({ clubId: clubDetails.id });
        }
    }, []);

    useEffect(() => {
        if (isHighschool) {
            if (highSchoolStandingsSeasons.length > 0) {
                setSelectedSeason(highSchoolStandingsSeasons[0]);
            }
        }
    }, [highSchoolStandingsSeasons]);

    const resultsTypeOptions = [
        {
            label: 'Singles',
            value: 'singles',
        },
        {
            label: 'Doubles',
            value: 'doubles',
        },
    ];
    const selectedResultsType = _.find(resultsTypeOptions, { value: resultsType });
    const userPlayerId = auth.user && auth.user.claimedPlayer && auth.user.claimedPlayer.playerId;
    const totalResultsCount = clubDetails.resultCount;
    const canPostScores = _.get(clubDetails, 'tierType.canPostScores', false);

    if (resultsFetchState.loading) {
        return (
            <div>
                <LoadingText text={'Loading Results'} />
            </div>
        );
    }

    const showSeasonFilter = (clubDetails?.tierType?.isHighSchool && clubDetails?.schoolProfile);

    const handleResultTypeSelection = (selection) => {
        if (selection.value !== props.resultsType) {
            props.changeResultsType(selection.value);
        }
    };

    const handleSeasonChange = (e) => {
        setSelectedSeason(parseInt(e.target.value));
    };

    const getSeasonYearDisplay = (year) => {
        return `${year} - ${(year % 1000) + 1}`;
    };

    const filterBySeason = (event) => {
        if (event.startDate && moment(event.startDate).isBetween(`${selectedSeason}-07-01`, `${selectedSeason + 1}-06-30`)) {
            return true;
        }
        return false;
    };

    return (
        <>
            {showSeasonFilter && (
                <div className={`row`}>
                    <div className={`col-md-12`}>
                        <h6 className="text-uppercase">
                            <div className="form-inline mb16">
                                <div className={`d-flex align-items-center justify-content-center`}>
                                    <label className="text-uppercase mt12 mr16">Season</label>
                                    <div className="input-wrapper mr8">
                                        <select
                                            className="form-control form-control-sm"
                                            value={selectedSeason}
                                            onChange={handleSeasonChange}
                                        >
                                            {highSchoolStandingsSeasons && highSchoolStandingsSeasons.length && (
                                                <>
                                                    {highSchoolStandingsSeasons.map(season => {
                                                        return <option key={season} value={season}>{getSeasonYearDisplay(season)}</option>;
                                                    })}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </h6>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-md-8">
                    <div className="d-block d-md-none">
                        <SidePanelTopSection
                            auth={auth}
                            clubType={clubType}
                            clubDetails={clubDetails}
                            handleUploadPhoto={handleUploadPhoto}
                            handleUploadLogoStart={handleUploadLogoStart}
                            removeSponsorLogo={removeSponsorLogo}
                            sendMessage={sendMessage}
                        />
                    </div>
                    {(clubDetails && clubDetails.resultCount > 0) ? (
                        <>
                            <div>
                                <div className={`d-inline-block ${styles.titleMargins}`}>
                                    <PopOverMenu
                                        anchorClass={`${styles.anchorClass}`}
                                        menuItems={resultsTypeOptions}
                                        onSelected={handleResultTypeSelection}
                                        alignLeft={true}
                                    >
                                        <h6 className="text-uppercase mt0 mb0 pl8">
                                            {selectedResultsType ? selectedResultsType.label : 'Singles'} <i className={`${styles.arrow} uts uts-expand`} />
                                        </h6>
                                    </PopOverMenu>
                                </div>
                            </div>
                            <ResultsList
                                showVerified={true}
                                gameType={resultsType}
                                results={showSeasonFilter ? { events: results?.events.filter(filterBySeason) } : results}
                                auth={auth}
                                playerId={userPlayerId}
                                limitResultDisplay={true}
                                resultsLoading={resultsFetchState.loading}
                                totalResultsCount={totalResultsCount}
                                clubType={clubType}
                            />
                            {results && results.events && results.events.length > 0 && !resultsFetchState.loading && (totalResultsCount > resultsFetchState.totalResultsFetched) && (
                                <div className="d-flex flex-row align-items-center">
                                    <button
                                        type="button"
                                        className="btn btn-default btn-xl mr-auto"
                                        onClick={(ev) => {
                                            fetchClubResults();
                                        }}
                                    >
                                        Load More
                                    </button>
                                </div>
                            )}
                        </>

                    ) : (

                        (isAdminOrOwner && canPostScores) ? (
                            <div className={`${styles.placeHolderGrid}`}>
                                <div className={`${styles.overlay}`} />
                                <div className={`${styles.actionWrapper}`}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-sm text-uppercase`}
                                        onClick={(ev) => {
                                            if (!isActive(clubDetails)) {
                                                props.showInactivePopup();
                                            } else {
                                                props.history.push(`/${clubType}/${clubDetails.id}/post-score`);
                                            }
                                        }}
                                    >
                                        Post Scores
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="row mt64">
                                <div className="col-12">
                                    <p className="text-center">No results have been posted yet<br />
                                        Check back for match results
                                    </p>
                                </div>
                            </div>
                        )
                    )}
                </div>
                <div className="col-md-4">
                    <div className="d-none d-md-block">
                        <SidePanel
                            auth={auth}
                            clubType={clubType}
                            clubDetails={clubDetails}
                            handleUploadPhoto={handleUploadPhoto}
                            handleUploadLogoStart={handleUploadLogoStart}
                            removeSponsorLogo={removeSponsorLogo}
                            sendMessage={sendMessage}
                        />
                    </div>
                    <div className="d-block d-md-none">
                        <SidePanelBottomSection
                            clubDetails={clubDetails}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

ResultsTabContent.propTypes = {
    clubDetails: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(ResultsTabContent);
